import { IsAuthenticatedGuard } from '@ip6m/server/auth';
import { CustomerLists, CustomersBySerial } from '@ip6m/types';
import { Controller, Get, Param, UseGuards } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { Observable } from 'rxjs';
import { CustomerService } from './services/customer.service';

@ApiTags('customer-api')
@Controller('v1/customer')
@UseGuards(IsAuthenticatedGuard)
export class CustomerController {

    constructor(private readonly customerService: CustomerService ) {}

    @Get('')
    customer(): Observable<CustomerLists> {
      return this.customerService.getCustomers();
    }

    @Get('type/:dbtype')
    customerByDb(@Param() params): Observable<CustomersBySerial> {
      return this.customerService.getCustomersByDb(params.dbtype);
    }

    @Get('/status')
    customerStatus() {
      return this.customerService.status;
    }

    @Get('ont/:sn')
    customerBySn(@Param() params) {
      return this.customerService.getCustomers(params.sn);
    }

}
